import { render, staticRenderFns } from "./NewSetting.vue?vue&type=template&id=1c1dc232&scoped=true"
import script from "./NewSetting.vue?vue&type=script&lang=js"
export * from "./NewSetting.vue?vue&type=script&lang=js"
import style0 from "./NewSetting.vue?vue&type=style&index=0&id=1c1dc232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1dc232",
  null
  
)

export default component.exports